import { render, staticRenderFns } from "./LoadingReservations.vue?vue&type=template&id=4ed9d9ee"
import script from "./LoadingReservations.vue?vue&type=script&lang=js"
export * from "./LoadingReservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports